import { Component, Input, ViewEncapsulation } from '@angular/core';
import copyToClipboard from 'copy-to-clipboard';
import { BcAnalytics } from 'common/analytics/analytics.service';

@Component({
  selector: 'app-copy-text-to-clipboard',
  templateUrl: './copy-text-to-clipboard.component.html',
  styleUrls: ['./copy-text-to-clipboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CopyTextToClipboardComponent {
  @Input()
  textToCopy: string;

  @Input()
  linkText: string;

  constructor(private _bcAnalytics: BcAnalytics) {

  }

  copyTextToClipboard(event) {
    copyToClipboard(this.textToCopy);
    this._bcAnalytics.eventTrack('CopyChatId');
    event.stopPropagation();
  }
}
